import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { useGiftCardInfoStyles } from './styles';

const GiftCardInfo = ({ ...props }) => {
  const { mobile, cardStatus, initialAmount, validity } = props;

  const classes = useGiftCardInfoStyles({ mobile });

  const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  return (
    <Box
      width="100%"
      className={classes.container}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Typography
        variant="h3"
        className={classes.title}
        data-cy="typoGiftCardInfo"
      >
        Información de tu Gift Card
      </Typography>
      <List dense>
        <ListItem>
          <ListItemText>
            <Typography className={classes.listItemText}>
              <strong>Estado:</strong> {capitalize(cardStatus)}
            </Typography>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            <Typography className={classes.listItemText}>
              <strong>Monto inicial:</strong> ${initialAmount}{' '}
            </Typography>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            <Typography className={classes.listItemText}>
              <strong>Vigencia:</strong> {validity}{' '}
            </Typography>
          </ListItemText>
        </ListItem>
      </List>
    </Box>
  );
};

GiftCardInfo.propTypes = {
  mobile: PropTypes.bool,
  cardStatus: PropTypes.string,
  initialAmount: PropTypes.string,
  validity: PropTypes.string,
};

export default GiftCardInfo;
